import * as HttpService from "../../../../service/HttpService";

/** 运行监控  -> 对比分析服务 **/

/**
 * 获取曲线封装
 * @param type 类型 0: 日  1:月  2:年
 * @param params
 */
export const getCurves = (type, params) => {
    switch (type) {
        case "0": return getDayCurves(params.startDate, params.superiorId);
        case "1": return getMonthCurves(params.startDate, params.endDate, params.superiorId);
        case "2": return getYearCurves(params.startDate, params.endDate, params.superiorId);
        default: return getDayCurves(params.startDate, params.superiorId);
    }
}

/**
 * 获取日曲线
 * @param dateDay 日
 * @param superiorId 树节点id
 */
const getDayCurves = (day, superiorId) => {
    return HttpService.post(HttpService.DOMAIN + "/peidianComparativeAnalysis/getPeidianComparativeAnalysisCurveDay?dateDay=" + day + "&superiorId=" + superiorId, {});
}

/**
 * 获取月曲线
 * @param startDay 开始日期
 * @param endDay 结束日期
 * @param superiorId 树节点id
 */
const getMonthCurves = (startDate, endDate, superiorId) => {
    return HttpService.post(HttpService.DOMAIN  + "/peidianComparativeAnalysis/getPeidianComparativeAnalysisCurveMonth?startDate=" + startDate + "&endDate=" + endDate+ "&superiorId=" + superiorId, {});
}


/**
 * 获取年曲线
 * @param startMonth 开始月
 * @param endMonth 结束月
 * @param superiorId 树节点id
 */
const getYearCurves = (startDate, endDate, superiorId) => {
    return HttpService.post(HttpService.DOMAIN  + "/peidianComparativeAnalysis/getPeidianComparativeAnalysisCurveYear?startDate=" + startDate + "&endDate=" + endDate+ "&superiorId=" + superiorId, {});
}

/**
 * 获取对比分析曲线
 * @returns {Promise<Response>}
 */
export const getCompareCurves = (data) => {
    return HttpService.post(HttpService.DOMAIN + "/pQContrast/addContrastCurve", data);
}

/**
 * 获取节点的数据项
 * @param ceResSortNo  设备类型 例: DEV_PV_INVERTER
 */
export const getDataItem = (ceResSortNo,id) => {
    return HttpService.get(HttpService.DOMAIN + "/pQContrast/getContrastDataItemList?ceResSortNo=" + ceResSortNo+"&id="+id)
}
